/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import Icon from '../../Atoms/Icon';
import Picture from '../../Picture';

const propTypes = exact({
  blockName: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.string,
      icon: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
});

const defaultProps = {
  blockName: null,
  selectedIds: [],
};

const NO_CATEGORY = 'NO_CATEGORY';

class ImageDropdown extends Component {
  constructor(props) {
    super(props);

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.toggleList = this.toggleList.bind(this);

    this.container = null;

    this.state = {
      isActive: false,
      categories: [],
      selectedIds: this.props.selectedIds,
      activeCategory: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { selectedIds } = nextProps;
    if (selectedIds === this.state.selectedIds) return;
    this.setState({ selectedIds });
  }

  componentDidMount() {
    const hasCategories = this.props.data.some((option) => !!option.category);

    const categories = [];
    if (hasCategories) {
      this.props.data.forEach((option) => {
        if (option.category) {
          const category = categories.find((x) => x.text === option.category);
          if (category) {
            category.options.push(option);
          } else {
            categories.push({
              text: option.category,
              options: [option],
            });
          }
        }
      });
    } else {
      categories.push({
        text: NO_CATEGORY,
        options: this.props.data,
      });
    }

    this.setState({ categories, activeCategory: 0 });
  }

  toggleList() {
    this.setState(
      (prevState) => ({ isActive: !prevState.isActive }),
      () => {
        if (this.state.isActive) document.addEventListener('click', this.handleDocumentClick);
        else document.removeEventListener('click', this.handleDocumentClick);
      }
    );
  }

  handleDocumentClick(event) {
    if (!this.container) return;

    const clickedInContainer = this.container.contains(event.target);
    const clickedOnContainer = this.container === event.target;

    if (!clickedOnContainer && !clickedInContainer) this.toggleList();
  }

  handleListClick(id) {
    this.setState({ activeCategory: id });
  }

  handleImageClick(id) {
    const { selectedIds } = this.state;

    if (selectedIds.includes(id)) {
      this.setState({ selectedIds: selectedIds.filter((selectedId) => selectedId !== id) }, () =>
        this.props.onChange(this.props.fieldName, this.state.selectedIds)
      );
    } else {
      this.setState({ selectedIds: [...selectedIds, id] }, () =>
        this.props.onChange(this.props.fieldName, this.state.selectedIds)
      );
    }
  }

  handleResetClick() {
    this.setState({ selectedIds: [] }, () => this.props.onChange(this.props.fieldName, []));
  }

  render() {
    const { isActive, selectedIds, activeCategory, categories } = this.state;
    const { data, blockName, labelText } = this.props;

    const filteredItems = data.filter((item) => selectedIds.includes(item.id));
    const selectedText = filteredItems.map((item) => item.title).join(', ');

    return (
      <div
        className={classNames(blockName, 'ImageDropdown', {
          active: isActive,
        })}
        ref={(element) => {
          this.container = element;
        }}
      >
        <button type="button" className="ImageDropdown_button" onClick={this.toggleList}>
          <span className="ImageDropdown_label">{labelText}</span>
          <div className="ImageDropdown_value">{selectedText || 'All'}</div>
        </button>
        <div className="ImageDropdown_listContainer">
          <div className="ImageDropdown_listBackground">
            <ul className="ImageDropdown_list">
              {categories.length > 0 &&
                categories
                  .filter((listItem) => listItem.text !== NO_CATEGORY)
                  .map((listItem, index) => (
                    <li
                      key={listItem.text}
                      className={classNames('ImageDropdown_item', {
                        active: index === activeCategory,
                        hasSelected: listItem.options.some((item) => selectedIds.includes(item.id)),
                      })}
                    >
                      <button
                        type="button"
                        className="Button"
                        onClick={() => this.handleListClick(index)}
                      >
                        {listItem.text}
                      </button>
                    </li>
                  ))}
              <li className="ImageDropdown_itemReset">
                <button type="button" className="Button" onClick={() => this.handleResetClick()}>
                  Clear all selections
                </button>
              </li>
            </ul>
            <ul className="ImageDropdown_sublist">
              {categories.length > 0 &&
                categories[activeCategory].options.map((item) => {
                  const image = item.image ?? item.icon;
                  return (
                    <li key={item.id} className="ImageDropdown_sublistItem">
                      <div
                        className="ImageDropdown_imageContainer"
                        onClick={() => this.handleImageClick(item.id)}
                      >
                        {selectedIds.includes(item.id) && (
                          <div className="ImageDropdown_check">
                            <Icon id="tick" />
                          </div>
                        )}
                        {image && (
                          <Picture
                            {...image}
                            className="ImageDropdown_image"
                            sizes={[
                              [100, 1.77],
                              [100, 1.77],
                              [50, 1.77],
                              ['727', 1.77],
                              ['727', 1.77],
                              ['727', 1.77],
                            ]}
                          />
                        )}
                        <div className="ImageDropdown_imageTitle">{item.title}</div>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

ImageDropdown.propTypes = propTypes;
ImageDropdown.defaultProps = defaultProps;

export default ImageDropdown;
